import Banner from '../components/Banner';
import Footer from '../components/Footer';

function ErrorPage() {
  return (
    <div className="page error-page">
      <Banner selected="none" />
      <div className="contents">
        <h1 className="error">404 Not Found</h1>
      </div>
      <Footer />
    </div>
  );
}

export default ErrorPage;
